"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Indicator = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Indicator = exports.Indicator = _styledComponents["default"].div.withConfig({
  displayName: "Indicator",
  componentId: "sc-1dk1c5h-0"
})(["display:flex;align-items:center;overflow-wrap:break-word;> *{max-inline-size:100%;}&::before{flex-shrink:0;background-color:", ";block-size:8px;inline-size:8px;border-radius:", ";margin-inline-end:", ";content:'';}"], function (props) {
  return (0, _index.cssColorValue)(props.$statusColor);
}, _index.borderRadiusRounded, (0, _index.cssSpacing)('tighter-2', '8px'));